export default "__VITE_ASSET__CLwVIosf__"